import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToImproveProcesses');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace">
                                                <p>If you found this tool useful then you are likely to find
                                                    the following tools both insightful and relevant: </p>
                                            </div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}>How
                                                        to gain buy-in and commitment </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBeInnovative')}>How
                                                        to be innovative </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToThinkAboutProblemsLaterally')}>How
                                                        to think about problems laterally </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeComplexIdeasSimpleClearAndConcise')}>How
                                                        to make complex ideas simple, clear and
                                                        concise. </div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>
                                            <ol className="testclass">
                                                <li><p className="further_info_content">Gick,
                                                    M. &amp; Holyoak, K. (1980). Analogical problem solving.<span
                                                        className="subtiltereg">  Cognitive Psychology,</span> 12,
                                                    306-355.</p></li>
                                                <li><p className="further_info_content">Furst, S.
                                                    A., &amp; Cable, D. M. (2008). Employee resistance to
                                                    organizational change: Managerial influence tactics and
                                                    leader-member exchange. <span className="subtiltereg">Journal of Applied Psychology,</span> 93(2),
                                                    453.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}